///
/// EarthBrowser
///
/// Migration v15 to v16: Add GeoPackage Download Directory
///
/// Adds geopackageDownloadDirectoryId field for storing the user's selected
/// download directory for GeoPackage files (File System Access API)
///
/// Created by Matt Giger on December 23, 2025
/// Copyright (c) 2025 Geodata Labs
///

export function migrateV15toV16(state: unknown): unknown {
	return {
		...(state as Record<string, unknown>),
		geopackageDownloadDirectoryId: null
	}
}
